import MainModal from '@/common/components/base/modal/Modal.tsx';
import { MainModalProps } from '@/common/components/base/modal/Modal.type.ts';
import ClipboardIcon from '@/common/assets/icons/clipboardIcon.svg?react';
import { useQuery } from '@tanstack/react-query';
import { Box, Center } from 'styled-system/jsx';
import CircularLoading from '@/common/components/base/Loading/CircularLoading.tsx';
import TitleDescription from '@/common/components/base/typography/TitleDescription.tsx';
import CardButton from '@/common/components/cardButton/CardButton.tsx';
import CustomIcon from '@/common/components/base/customIcon/CustomIcon.tsx';
import { token } from 'styled-system/tokens';
import CustomLabel from '@/common/components/base/customLabel/CustomLabel.tsx';
import { referredFileNumberQueryOption } from '@/modules/Dashboard/queries/referredFileNumbers/referredFileNumberQueryOption.ts';
import { FILE_LIST_LINKS } from '@/modules/FileList/fileListLinks.ts';
import { useNavigate } from 'react-router-dom';
import { FileStateType } from '@/common/types/Files.type';

export default ({ open, closeModal }: MainModalProps) => {
  return (
    <MainModal closeModal={closeModal} open={open}>
      <ReferredModal />
    </MainModal>
  );
};

const ReferredModal = () => {
  const navigate = useNavigate();
  const { data, isPending, isError } = useQuery(referredFileNumberQueryOption);
  if (isError) {
    return <></>;
  }
  if (isPending) {
    return (
      <Center height="311px">
        <CircularLoading color="colors.purple-primary" />
      </Center>
    );
  }

  return (
    <Box pb="15px">
      <TitleDescription mb="30px" textStyle="h2">
        پرونده‌های برگشتی
      </TitleDescription>
      <CardButton
        cardProps={{
          mb: '10px',
          onClick: () => {
            navigate(
              FILE_LIST_LINKS.myFilesWithParams({
                state: {
                  label: data?.refer_from_branch?.fa_name,
                  value: FileStateType.REFER_FROM_BRANCH,
                },
              }),
            );
          },
        }}
        renderTag={renderTag.bind(this, data?.refer_from_branch.count)}
        renderIcon={renderIcon}
        title={data?.refer_from_branch.fa_name}
      />
      <CardButton
        cardProps={{
          mb: '10px',
          onClick: () => {
            navigate(
              FILE_LIST_LINKS.myFilesWithParams({
                state: {
                  label: data?.refer_from_professional?.fa_name,
                  value: FileStateType.REFER_FROM_PROFESSIONAL,
                },
              }),
            );
          },
        }}
        renderTag={renderTag.bind(this, data?.refer_from_professional.count)}
        renderIcon={renderIcon}
        title={data?.refer_from_professional.fa_name}
      />
      <CardButton
        cardProps={{
          mb: '10px',
          onClick: () => {
            navigate(
              FILE_LIST_LINKS.myFilesWithParams({
                state: {
                  label: data?.refer_from_checking?.fa_name,
                  value: FileStateType.REFER_FROM_CHECKING,
                },
              }),
            );
          },
        }}
        renderIcon={renderIcon}
        renderTag={renderTag.bind(this, data?.refer_from_checking.count)}
        title={data?.refer_from_checking.fa_name}
      />
    </Box>
  );
};

const renderIcon = () => (
  <CustomIcon backgroundColor="purple-6" width="40px" height="40px">
    <ClipboardIcon stroke={token('colors.purple-primary')} />
  </CustomIcon>
);
const renderTag = (count: number) => <CustomLabel title={count.toString()} />;
